import { data, useOutletContext } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { getTransaksi } from "../api/services/sahamApi";
import { currencyFormat } from "../components/utils/currencyFormat";
import { formatDate } from "../components/utils/fomatDate";
import Card from "../components/cards/Card";
import TransactionCard from "../components/cards/TransactionCard";


function DaftarTransaksi() {
    
    /** Title Header Page */
    const {title, setTitle} = useOutletContext();
    setTitle('Transaksi Terakhir');
    
    /** useState */
    const [dataTransaksi, setDataTransaksi] = useState({
        data : [],
    });
    
        
    useEffect(() => {
        document.title = 'Daftar Transaksi | Sembako';
        getTransaksi(1).then(res => setDataTransaksi(res.data.data));
    },[])

    console.log(dataTransaksi);

    const disabledPrevButton = dataTransaksi.current_page == 1 ? true : false;
    const disabledNextButton = dataTransaksi.current_page == dataTransaksi.last_page ? true : false;

    function handleNextClick(e) {
        if(!disabledNextButton) {
            const nextPage = dataTransaksi.current_page + 1;
            getTransaksi(nextPage).then(res => setDataTransaksi(res.data.data));
        }
    }

    function handlePrevClick(e) {
        if(!disabledPrevButton) {
            const prevPage = dataTransaksi.current_page - 1;
            getTransaksi(prevPage).then(res => setDataTransaksi(res.data.data));
        }
    }

    console.log(dataTransaksi);


    return(
        <>
            <div className="mt-10">
                <div className="flex justify-between items-center">
                </div>
                    {
                        dataTransaksi.data.map((val, i) => 
                            <TransactionCard 
                                header={`No. ${val.saham.nomer} - ${val.saham.nama}`}
                                type={val.type_transaksi}
                                id={val.id}
                                date={formatDate(val.updated_at)}
                                jumlahSembako={val.jumlah_sembako}
                                jmlSaham={val.jml_saham}
                                nomerSembako={val.nomer_sembako}
                                jumlahTabungan={val.jumlah_tabungan}
                            />
                        )
                    }
                    <div className="mt-10 flex justify-around centex items-center">
                        <button className="disabled:opacity-10 text-[#8570FF]" disabled={disabledPrevButton} onClick={(e) => handlePrevClick(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" 
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-left"><path stroke="none" 
                                d="M0 0h24v24H0z" fill="none"/><path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18" />
                                <path d="M8 12l4 4" /><path d="M8 12h8" /><path d="M12 8l-4 4" /></svg></button>
                        <span>{dataTransaksi.current_page} / {dataTransaksi.last_page}</span>
                        <button className="disabled:opacity-10 text-[#8570FF]" disabled={disabledNextButton} onClick={(e) => handleNextClick(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" 
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                                class="icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-right"><path stroke="none" 
                                d="M0 0h24v24H0z" fill="none"/><path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
                                <path d="M16 12l-4 -4" /><path d="M16 12h-8" /><path d="M12 16l4 -4" /></svg>
                        </button>
                    </div>
            </div>
        </>
    );
}

export default DaftarTransaksi;